import React, { useContext } from 'react'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import Head from 'next/head'
import ConditionalRender, {
  Original,
  Experiment
} from '@/components/ConditionalRender'
import { AppDownloadBannerContentType } from './types'
import { getPropsForAppBanner } from './utils'
import useAppBanner from './useAppBanner'
import AppBanner from './AppBanner'

const AppBannerWrapper = ({
  content,
  ...props
}: {
  content: AppDownloadBannerContentType
} & Record<string, unknown>) => {
  const showAppBanner = useAppBanner()
  const bootstrapData = useContext(BootstrapDataContext)
  const RenderAppBanner = () => {
    return showAppBanner ? (
      <AppBanner
        {...{
          ...getPropsForAppBanner(bootstrapData),
          ...content,
          ...props
        }}
      />
    ) : null
  }

  return bootstrapData.isIOS ? (
    <ConditionalRender experimentCode="MBL_IOS_SMART_BANNER">
      <Original>
        <RenderAppBanner />
      </Original>
      <Experiment>
        <Head>
          <meta
            name="apple-itunes-app"
            content="app-id=336381998"
            key="apple-smart-banner"
          />
        </Head>
      </Experiment>
    </ConditionalRender>
  ) : (
    <RenderAppBanner />
  )
}

export default AppBannerWrapper
